import { createContext, useState } from "react";

const GlobalContext = createContext(null)

function GlobalState({ children }) {
    const [urlReferral,setUrlReferral] = useState(null);
    return (
        <GlobalContext.Provider value={(
            {
setUrlReferral,
            urlReferral
            }
        )
            
            }>
            {children}
        </GlobalContext.Provider>
    );
}
export default GlobalState;
export { GlobalContext };